import React, { useEffect } from 'react';
import Chart, { Props as ApexProps } from 'react-apexcharts';
import * as ru from 'apexcharts/dist/locales/ru.json';

import { ChartWrapper } from '../../../components/Charts/ChartWrapper';
import { useAppSelector } from '../../../../../store';
import { useLazyGetMembersQuery } from '../service/members.api';
import { AnalyticsFiltersProps } from '../../AnalyticsFilters/service/filters.interface';
import { selectAnalyticsFilters } from '../../../store/analyticFiltersSlice';

const labelFormat = (filters: Partial<AnalyticsFiltersProps>): string => {
    switch (filters.period) {
        case 'day': {
            return 'HH:mm';
        }
        case 'week': {
            return 'ddd';
        }
        case 'month': {
            return 'dd';
        }
        case 'year': {
            return 'MMM';
        }
    }
};

export const MembersMultiLineChart = () => {
    const filters = useAppSelector(selectAnalyticsFilters);
    const colors = ['#D6E4FF', '#ADC6FF', '#85A5FF', '#597EF7'];

    const [getMembers, { data, isFetching, isLoading }] =
        useLazyGetMembersQuery();

    useEffect(() => {
        if (filters) {
            const payload = {
                ...filters,
                community_id: Number(filters.chat) || null,
            };
            getMembers(payload, true);
        }
    }, [filters]);

    const options: ApexProps['options'] = {
        labels: [],
        chart: {
            toolbar: {
                show: false,
            },
            zoom: {
                enabled: false,
            },
            locales: [ru],
            defaultLocale: 'ru',
        },
        legend: {
            show: true,
            position: 'left',
        },
        xaxis: {
            type: 'datetime',
            labels: {
                format: labelFormat(filters),
            },
            tickAmount: 6,
        },
        colors: colors,
        markers: {
            colors: colors,
        },
    };

    return (
        <ChartWrapper isLoading={isFetching} title='Участники'>
            <Chart
                height={'200px'}
                type='line'
                options={options}
                series={[
                    {
                        type: 'line',
                        name: 'Участников',
                        data: data?.series.map(s => ({
                            x: s.timestamp,
                            y: s.users,
                        })),
                    },
                ]}
            />
        </ChartWrapper>
    );
};
